var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overflow-x-auto table-btn-group"},[_c('div',{staticClass:"flex"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"h-26px diy-table-button relative px-8px text-12px cursor-pointer flex-shrink-0",class:{
        active: _vm.value === item,
        'ml-10px': index !== 0,
        '!cursor-not-allowed': _vm.disabledList.includes(item),
      },on:{"click":function($event){return _vm.btnClick(item)}}},[_vm._v("\n      "+_vm._s(item)+"\n    ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }